package org.hs_soft.runmynesto.domain.usecase.options.cash_register_config

import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.devices.create_new_shop.CreateNewShopModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.CreateNewShopRepository


class CreateNewShopUseCase(
    private val repository: CreateNewShopRepository
) {
    suspend operator fun invoke(
       name:String,
       regionId:String,
    ): CreateNewShopModel {
        return repository.createNewShop(
            name=name,
            regionId =regionId
        )
    }
}